export const LOCALES ={
	TURKISH: 'tr-tr',
	ENGLISH: 'en-us',
	GERMAN: 'de-de',
	FRENCH: 'fr-ca',
	RUSSIAN: 'ru-ru'
};